export default "__VITE_ASSET__DSPAx3UL__"